
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const customisableSelectStyle = {
  ...customSelectStyle
};

export default customisableSelectStyle;